import { sortBy } from 'lodash';

export const OPERATOR_NAMES = {
  empty: 'EMPTY',
  notEmpty: 'NOT_EMPTY',
  contains: 'CONTAINS',
  notContains: 'NOT_CONTAINS',
  equals: 'EQUALS',
  notEquals: 'NOT_EQUALS',
  anyOf: 'ANY_OF',
  noneOf: 'NONE_OF',
  between: 'BETWEEN',
  dateEquals: 'DATE_EQUALS',
  dateNotEquals: 'DATE_NOT_EQUALS',
  dateBefore: 'DATE_BEFORE',
  dateAfter: 'DATE_AFTER',
  notBetween: 'NOT_BETWEEN',
};

export const combinators = [
  { name: 'AND', label: 'All' },
  { name: 'OR', label: 'Any' },
];

export const textOperators = sortBy(
  [
    { name: OPERATOR_NAMES.empty, label: 'Is empty', color: '#d8d8d8' },
    { name: OPERATOR_NAMES.notEmpty, label: 'Is not empty', color: '#1b6064' },
    { name: OPERATOR_NAMES.contains, label: 'Contains', color: '#9ec771' },
    { name: OPERATOR_NAMES.notContains, label: 'Does not contain', color: '#a75187' },
    { name: OPERATOR_NAMES.equals, label: 'Is', color: '#599b78' },
    { name: OPERATOR_NAMES.notEquals, label: 'Is not', color: '#8c4c92' },
  ],
  'label',
);

export const dropDownOperators = sortBy(
  [
    { name: OPERATOR_NAMES.empty, label: 'Is empty', color: '#d8d8d8' },
    { name: OPERATOR_NAMES.notEmpty, label: 'Is not empty', color: '#1b6064' },
    { name: OPERATOR_NAMES.equals, label: 'Is', color: '#599b78' },
    { name: OPERATOR_NAMES.notEquals, label: 'Is not', color: '#8c4c92' },
    { name: OPERATOR_NAMES.anyOf, label: 'Any of', color: '#718fc4' },
    { name: OPERATOR_NAMES.noneOf, label: 'None of', color: '#67224d' },
  ],
  'label',
);

export const datesOperators = sortBy(
  [
    { name: OPERATOR_NAMES.empty, label: 'Is empty', color: '#d8d8d8' },
    { name: OPERATOR_NAMES.notEmpty, label: 'Is not empty', color: '#1b6064' },
    { name: OPERATOR_NAMES.dateEquals, label: 'Is', color: '#599b78' },
    { name: OPERATOR_NAMES.dateNotEquals, label: 'Is not', color: '#8c4c92' },
    { name: OPERATOR_NAMES.dateBefore, label: 'Is before', color: '#fdc86b' },
    { name: OPERATOR_NAMES.dateAfter, label: 'Is after', color: '#71bcc4' },
    { name: OPERATOR_NAMES.between, label: 'Is in the range (from-to)', color: '#71c498' },
    { name: OPERATOR_NAMES.notBetween, label: 'Is not in the range (from-to)', color: '#e69497' },
  ],
  'label',
);

export const operatorNameToLabel = [...textOperators, ...dropDownOperators, ...datesOperators].reduce((acc, { name, label }) => {
  acc[name] = label;

  return acc;
}, {});

export const operatorsByType = {
  autocomplete: textOperators,
  text: textOperators,
  chargerPackage: textOperators,
  select: dropDownOperators,
  date: datesOperators,
};

export const EMPTY_OPTIONS = ['EMPTY', 'NOT_EMPTY'];

export const FIELDS_WITH_SELECT = [
  'country',
  'ac_hw_version',
  'p_type',
  'maintainer',
  'owner',
  'supervisor',
  'status',
  'chademo_cable',
  'f_status',
  'condition',
  'charger_configuration_status',
  'charger_state',
  'online',
  'plaza_uuid',
  'customer_id',
  'enclosure',
  'product_level',
  'product_version',
];

export const defaultOperatorByType = {
  autocomplete: OPERATOR_NAMES.contains,
  text: OPERATOR_NAMES.contains,
  chargerPackage: { name: OPERATOR_NAMES.contains, version: OPERATOR_NAMES.notEmpty },
  select: OPERATOR_NAMES.equals,
  date: OPERATOR_NAMES.dateEquals,
};

export const emptyQuery = {
  id: 'g-query-root',
  combinator: 'AND',
  rules: [],
};

export const CONFIGURATIONS_FIELD_NAME = {
  nodeName: 'config_node_name',
  parameterName: 'parameter_name',
  valueName: 'parameter_value',
};

export const levelsColors = ['rgb(253, 196, 97)', 'rgb(114, 188, 196)', 'rgb(114, 143, 195)'];
